var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11V22.5C3 22.7761 3.22386 23 3.5 23H6M3 11L4.90892 6.2277C4.96637 6.08407 5.08706 5.97512 5.2358 5.93263L11.8626 4.03925C11.9524 4.0136 12.0476 4.0136 12.1374 4.03925L18.7642 5.93263C18.9129 5.97512 19.0336 6.08407 19.0911 6.2277L21 11M3 11L2 12.5M21 11V22.5C21 22.7761 20.7761 23 20.5 23H18M21 11L22 12.5M6 23V16M6 23H12M6 23L12 16M6 16H12M6 16L12 23M18 16V23M18 16H12M18 16L12 23M18 23H12M18 23L12 16M12 16V23M10 6.5H14M10 6.5V12.5M10 6.5L14 12.5M14 6.5V12.5M14 6.5L10 12.5M14 12.5H10",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5V2C4 0.8 6 0.5 7 0.5C9.4 0.5 10 1.5 10 2V4.5M5.5 3H8.5M5.5 5H8.5",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarn);
export default __webpack_public_path__ + "static/media/Barn.96e84adb0418d6f862b01d9fb7d2def9.svg";
export { ForwardRef as ReactComponent };